
declare let _satellite: any;

function radVersion() {
	let raduiVersion = 'pc';
	const screenWidth = window.screen.width;
	if (screenWidth < 1024 && screenWidth >= 500) {
		raduiVersion = 'tablet';
	} else if (screenWidth < 500) {
		raduiVersion = 'mobile';
	}
	return raduiVersion;
}

export function onLoadAnalytics(pageName: string, siteSection: string, hierarchy: string, rule: string,
								status: string, client: string, site: string) {
	let digitaldata;
	digitaldata = digitaldata || {};
	digitaldata.event = [];
	digitaldata = {
		page: {
			pageName,
			siteSection,
			hierarchy,
			userLanguage: 'eng',
			pageNameNoVehicle: pageName,
			client,
			site,
			radUIVersion: 'ui:rad:' + radVersion()
		},
		user: {
			loginStatus: status
		}
	};
	try {
		window['digitaldata'] = digitaldata;
		_satellite.track(rule);
	} catch (e) {
	}
}

interface OnVehicleClickAnalyticsParams {
	page: string;
	siteSection: string;
	hierarchy: string;
	rule: string;
	client: string;
	site: string;
	modelYear: string;
	nameplate: string;
	currentMake: string;
	linkName: string;
	onclick: string;
	formInput: string;
}

export function onVehicleClickAnalytics({
											page,
											formInput,
											siteSection,
											hierarchy,
											rule,
											client,
											site,
											modelYear,
											nameplate,
											currentMake,
											linkName,
											onclick
										}: OnVehicleClickAnalyticsParams) {
	let digitaldata;
	digitaldata = digitaldata || {};
	digitaldata.event = [];
	digitaldata = {
		onclick: {
			linkName,
			onclick
		},
		page: {
			pageName: page,
			siteSection,
			hierarchy,
			formInput: formInput,
			userLanguage: 'eng',
			pageNameNoVehicle: page,
			client,
			site,
			radUIVersion: 'ui:rad:' + radVersion()
		},
		user: {
			customerID: '',
			pegaID: ''
		},
		vehicle: {
			modelYear,
			nameplate,
			currentMake
		}
	};
	try {
		window['digitaldata'] = digitaldata;
		_satellite.track(rule);
	} catch (e) {
	}
}

interface OnPaymentEstimatorClickAnalyticsParams {
	page: string;
	siteSection: string;
	hierarchy: string;
	rule: string;
	client: string;
	site: string;
	modelYear: string;
	nameplate: string;
	linkName: string;
	onclick: string;
	bodyModelTrim: string;
	currentMake: string;
	formInput: string;
}

interface OnApplyOnlineClickAnalyticsParams {
	linkName: string;
	onclick: string;
	apr: string;
	terms: string;
	annualMiles: string;
	downloadPdf: string;
	downPayment: string;
	incentives: string;
	tradeIn: number;
	formInput: string;
	leaseVsOwn: string;
	bodyModelTrim: string;
	currentMake: string;
	modelYear: string;
	nameplate: string;
	rule: string;
}

export function onPaymentEstimatorClickAnalytics({
													 page,
													 formInput,
													 siteSection,
													 hierarchy,
													 rule,
													 client,
													 site,
													 modelYear,
													 nameplate,
													 linkName,
													 onclick,
													 bodyModelTrim,
													 currentMake
												 }: OnPaymentEstimatorClickAnalyticsParams) {
	let digitaldata;
	digitaldata = digitaldata || {};
	digitaldata.event = [];
	digitaldata = {
		onclick: {
			linkName,
			onclick
		},
		page: {
			siteSection,
			hierarchy,
			formInput: formInput,
			userLanguage: 'eng',
			pageNameNoVehicle: page,
			client,
			site,
			radUIVersion: 'ui:rad:' + radVersion()
		},
		user: {
			customerID: '',
			pegaID: '',
			loginStatus: 'logged out'
		},
		vehicle: {
			modelYear,
			nameplate,
			bodyModelTrim,
			currentMake,
		}
	};
	try {
		window['digitaldata'] = digitaldata;
		_satellite.track(rule);
	} catch (e) {
	}
}

export function onApplyOnlineScheduleDriveAnalytics({linkName,
												onclick,
												apr,
												terms,
												annualMiles,
												downloadPdf,
												downPayment,
												incentives,
												tradeIn,
												formInput,
												leaseVsOwn,
												bodyModelTrim,
												currentMake,
												modelYear,
												nameplate,
												rule
											}: OnApplyOnlineClickAnalyticsParams) {


	let digitaldata;
	digitaldata = digitaldata || {};
	digitaldata.event = [];
	digitaldata = {
		onclick: {
			linkName,
			onclick,
			apr,
			terms,
			annualMiles,
			downloadPdf,
			downPayment,
			incentives,
			tradeIn,
			formInput,
			leaseVsOwn
		},
		vehicle: {
			modelYear,
			nameplate,
			bodyModelTrim,
			currentMake,
		}
	};
	try {
		window['digitaldata'] = digitaldata;
		_satellite.track(rule);
	} catch (e) {
	}
}

export function onLandingTrimPageAnalytics(page: string, rule: string
	,  modelYear: string, nameplate: string, currentMake: string, bodyModelTrim: string) {
	let digitaldata;
	digitaldata = digitaldata || {};
	digitaldata.event = [];
	digitaldata = {
		page: {
			pageName: page
		},
		vehicle: {
			bodyModelTrim,
			modelYear,
			nameplate,
			currentMake
		}
	};
	try {
		window['digitaldata'] = digitaldata;
		_satellite.track(rule);
	} catch (e) {
	}
}
